<template>
	<v-card outlined>
		<v-card-title
			v-text="'Assocatived devices'"
			class="justify-center body-1 primary pa-1"
		>			
		</v-card-title>
		<v-card-text>
			<input_table
				:info_table="info_to_table"
				:list_table="list_to_table"				
			></input_table>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				x-small
				color="primary"
				v-text="$ml.get('reset')"
				@click="reset()"
			></v-btn>
			<v-btn
				x-small
				color="error"
				v-text="$ml.get('delete')"
				@click="del()"
			></v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import input_table 			from '@/components/info/input_table.vue'
// import analytics_default    from '@/components/analytics/analytics_default.json'
	export default{
		name: 'assocatived_devices',
		components:{
			input_table
		}, // components
		props: [ 'info_module' ],
		data: (vm) => ({
			info_to_table: null,
			headers_modules:[				
				{ text: vm.$ml.get('name') , value: 'text', align: ''},
				{ text: 'uuid', value: 'deviceId', align: '' }, 
				{ text: 'actions', value: 'action', align: 'center' },
			], // headers
			list_to_table: [], // list to table
		}), // data
		created(){
			let list 	= [],
				len 	= 0;
			if (localStorage.getItem('Device_Analytics')) {
				list = JSON.parse(localStorage.getItem('Device_Analytics'));
			}
			if (list && list.length > 0) {
				len 	= list.length;
				this.list_to_table = list;
			}
			this.info_to_table={
				headers: this.headers_modules,
				total: len,
				options: { itemsPerPage: 30 },
			}
		}, // created

		methods:{
			reset(){
				this.$EventBus.$emit('render_modules', { name: 'render' });

				if (localStorage.getItem('Device_Analytics')) {
					this.list_to_table = JSON.parse(localStorage.getItem('Device_Analytics'));
					 
				}

			}, // reset

			del(){
				if (localStorage.getItem('Device_Analytics')) {
					localStorage.removeItem('Device_Analytics');
					this.list_to_table = [];
					this.$EventBus.$emit('notifications_modal', {
						type: 'deleted',						
					})
				}
			}, // del

		}, // methods

		mounted(){
			this.$emit('info_from_component', this.list_to_table);
		}, // mounted
	};
</script>